/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { UserAccountSummary } from "./UserAccountSummary";
import {
    UserAccountSummaryFromJSON,
    UserAccountSummaryFromJSONTyped,
    UserAccountSummaryToJSON,
} from "./UserAccountSummary";

/**
 *
 * @export
 * @interface DeviceMaintenanceStatusLogDto
 */
export interface DeviceMaintenanceStatusLogDto {
    /**
     *
     * @type {number}
     * @memberof DeviceMaintenanceStatusLogDto
     */
    deviceMaintenanceStatusLogId?: number;
    /**
     *
     * @type {number}
     * @memberof DeviceMaintenanceStatusLogDto
     */
    deviceInstallationId?: number;
    /**
     *
     * @type {number}
     * @memberof DeviceMaintenanceStatusLogDto
     */
    userAccountId?: number;
    /**
     *
     * @type {Date}
     * @memberof DeviceMaintenanceStatusLogDto
     */
    createdAt?: Date;
    /**
     *
     * @type {string}
     * @memberof DeviceMaintenanceStatusLogDto
     */
    status?: DeviceMaintenanceStatusLogDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof DeviceMaintenanceStatusLogDto
     */
    notes?: string;
    /**
     * Currently set for Rectified status only.
     * @type {string}
     * @memberof DeviceMaintenanceStatusLogDto
     */
    subStatus?: DeviceMaintenanceStatusLogDtoSubStatusEnum;
    /**
     * User-entered date this occurred (as opposed to when it was logged).
     * @type {Date}
     * @memberof DeviceMaintenanceStatusLogDto
     */
    actionedAt?: Date;
    /**
     *
     * @type {UserAccountSummary}
     * @memberof DeviceMaintenanceStatusLogDto
     */
    userAccount?: UserAccountSummary;
}

/**
 * @export
 */
export const DeviceMaintenanceStatusLogDtoStatusEnum = {
    NotRectified: "NotRectified",
    Rectified: "Rectified",
    Other: "Other",
    Decommissioned: "Decommissioned",
} as const;
export type DeviceMaintenanceStatusLogDtoStatusEnum =
    (typeof DeviceMaintenanceStatusLogDtoStatusEnum)[keyof typeof DeviceMaintenanceStatusLogDtoStatusEnum];

/**
 * @export
 */
export const DeviceMaintenanceStatusLogDtoSubStatusEnum = {
    Other: "Other",
    RectifiedDuet: "Rectified_Duet",
    RectifiedCommissions: "Rectified_Commissions",
    RectifiedOnsiteTech: "Rectified_OnsiteTech",
} as const;
export type DeviceMaintenanceStatusLogDtoSubStatusEnum =
    (typeof DeviceMaintenanceStatusLogDtoSubStatusEnum)[keyof typeof DeviceMaintenanceStatusLogDtoSubStatusEnum];

/**
 * Check if a given object implements the DeviceMaintenanceStatusLogDto interface.
 */
export function instanceOfDeviceMaintenanceStatusLogDto(
    value: object,
): value is DeviceMaintenanceStatusLogDto {
    return true;
}

export function DeviceMaintenanceStatusLogDtoFromJSON(
    json: any,
): DeviceMaintenanceStatusLogDto {
    return DeviceMaintenanceStatusLogDtoFromJSONTyped(json, false);
}

export function DeviceMaintenanceStatusLogDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceMaintenanceStatusLogDto {
    if (json == null) {
        return json;
    }
    return {
        deviceMaintenanceStatusLogId:
            json["deviceMaintenanceStatusLogId"] == null
                ? undefined
                : json["deviceMaintenanceStatusLogId"],
        deviceInstallationId:
            json["deviceInstallationId"] == null
                ? undefined
                : json["deviceInstallationId"],
        userAccountId:
            json["userAccountId"] == null ? undefined : json["userAccountId"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        status: json["status"] == null ? undefined : json["status"],
        notes: json["notes"] == null ? undefined : json["notes"],
        subStatus: json["subStatus"] == null ? undefined : json["subStatus"],
        actionedAt:
            json["actionedAt"] == null
                ? undefined
                : new Date(json["actionedAt"]),
        userAccount:
            json["userAccount"] == null
                ? undefined
                : UserAccountSummaryFromJSON(json["userAccount"]),
    };
}

export function DeviceMaintenanceStatusLogDtoToJSON(
    value?: DeviceMaintenanceStatusLogDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceMaintenanceStatusLogId: value["deviceMaintenanceStatusLogId"],
        deviceInstallationId: value["deviceInstallationId"],
        userAccountId: value["userAccountId"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        status: value["status"],
        notes: value["notes"],
        subStatus: value["subStatus"],
        actionedAt:
            value["actionedAt"] == null
                ? undefined
                : value["actionedAt"].toISOString(),
        userAccount: UserAccountSummaryToJSON(value["userAccount"]),
    };
}
